import styled from 'styled-components';

export const CartRow = styled.td`  
font-size: 20px;
text-align: center;
font-family: 'Indie Flower', cursive;
`

export const TableTh = styled.th`  
font-size: 20px;
text-align: center;
font-family: 'Asap', sans-serif;
`
export const CartImg = styled.img`  
height: 45px;
width: 45px;
`
export const CartRowheight = styled.th`
font-family: 'Asap', sans-serif;
font-size: 20px;
text-align: end !important;
`

export const InputNumber = styled.input`
  width: 18%;
`
export const TextArea = styled.textarea`
    width: 30%;
    height: 100px ;
    outline: 0;
    background: #696969
    color:#F8F8FF ;
`
export const Line = styled.div`
border-bottom: 2px solid gray;
width: 15%;
margin-right: 35px;
`
export const StartViwe = styled.div`
background-repeat: no-repeat;
background-image: url('images/backgrounds/background2.png');
height:auto;
text-align: center;
position: relative;
padding-top:16%;
padding-bottom:15%;
font-family: 'Shadows Into Light', cursive;
 font-weight:bold;
 font-size: 60px;
`
export const ContactViwe = styled.div`
background-image: linear-gradient(to right, rgba(255,0,0,0), rgb(132, 0, 255));
font-family: 'Shadows Into Light', cursive;

`
export const ContactHistoryViweTitle = styled.div`
font-family: 'Shadows Into Light', cursive;
font-weight:bold;
font-size: 60px;
`

export const NoContactHistoryTitle = styled.div`
font-family: 'Shadows Into Light', cursive;
font-weight:bold;
font-size: 50px;
padding-bottom:23%;
`

export const HistoryViwe = styled.div`
background-image: linear-gradient(to bottom right, rgba(255,0,0,0), rgb(132, 0, 255));
`
export const HistoryUserInfo = styled.div`
font-size: 25px;
`
export const HistoryUserMesagges = styled.p`
font-size: 20px;
`